import React from "react";

interface ToggleProps {
  enabled: boolean;
  onToggle: () => void;
  /** Locks the switch (e.g. while a card is not in edit mode). */
  disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ enabled, onToggle, disabled = false }) => (
  <button
    type="button"
    onClick={onToggle}
    disabled={disabled}
    className={`relative h-5 w-8 rounded-full transition-colors ${enabled ? 'bg-slate-800' : 'bg-gray-300'} ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
  >
    <div className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${enabled ? 'translate-x-3.5' : 'translate-x-0.5'}`} />
  </button>
);

export default Toggle;
